import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { Tooltip } from "~/components/Tooltip";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";

// // // //

export const DESCRIPTION_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.description,
    sortsOn: AssetColumns.description,
    label: "Description",
    type: ColumnTypes.string,
    width: 320,
    render: (item) => {
        if (!item.isAsset) return null;

        const value = item.description;
        if (!value) return <Emdash />;

        return (
            <Tooltip
                placement="top"
                tooltipContent={
                    <div className="px-3 py-2 text-sm max-w-sm whitespace-pre-line">
                        {value}
                    </div>
                }
            >
                {({ setTriggerRef }) => (
                    <span ref={setTriggerRef} className="line-clamp-2">
                        {value}
                    </span>
                )}
            </Tooltip>
        );
    },
};
